export default __webpack_public_path__ + "static/media/Nunito-Bold.fffe8c43.woff";